import { Checkbox, TableCell, TableRow } from "@mui/material";
import React, { useState, useEffect } from "react";
import {
  images,
  showNotification,
  truncateString,
} from "../../../../../constants";
import StatusDropdown from "../../../../../common/StatusDropdown";
import moment from "moment";
import { useAuth } from "../../../../../hooks";
import { updateOrganization } from "../../../../../modules/OrgProf/hook/Organizationhook";
import { useOrganizationContext } from "../../../../../providers/OrganizationAdmin/OrganizationProvider";
import { Toast } from "../../../../../common/alert";

const GAOrganizationsTableRow = ({
  isItemSelected,
  row,
  numberType,
  handleClickRow,
  labelId,
  handleNavigateToDetails,
  handleImagePreviewModalOpen,
  setSelectedImage,
  columnWidths,
}) => {
  const { handleGetAllOrganizations, setLoading } = useOrganizationContext();

  const { currentUser } = useAuth();

  // Pin Order inline editing state
  const [pinOrderValue, setPinOrderValue] = useState(
    row?.pinOrder != null ? String(row.pinOrder) : ""
  );

  useEffect(() => {
    setPinOrderValue(row?.pinOrder != null ? String(row.pinOrder) : "");
  }, [row?.pinOrder]);

  const handleSavePinOrder = async () => {
    const newValue = pinOrderValue.trim();
    const parsedValue = newValue === "" ? null : parseInt(newValue, 10);

    // Validate: must be empty (null) or a valid integer
    if (newValue !== "" && (isNaN(parsedValue) || !(/^-?\d+$/.test(newValue)))) {
      // Revert to original value on invalid input
      setPinOrderValue(row?.pinOrder != null ? String(row.pinOrder) : "");
      return;
    }

    // Only save if the value actually changed
    const currentValue = row?.pinOrder ?? null;
    if (parsedValue === currentValue) return;

    try {
      let dataTemp = {
        pinOrder: parsedValue,
        updatedAt: new Date(),
        updatedBy: currentUser?.id,
      };
      await updateOrganization(row.id, dataTemp);
      await handleGetAllOrganizations();
      showNotification("Pin Order updated successfully.");
    } catch (error) {
      Toast("error", error.message);
      console.log("error updating pin order", error.message);
      // Revert on error
      setPinOrderValue(row?.pinOrder != null ? String(row.pinOrder) : "");
    }
  };

  const handleUpdateOrgStatus = async (status) => {
    try {
      setLoading(true);
      let dataTemp = {
        status: status,
        updatedAt: new Date(),
        updatedBy: currentUser?.id,
      };
      console.log(status, row.id);
      let responseTemp = await updateOrganization(row.id, dataTemp);
      console.log("update organization response:", responseTemp);
      await handleGetAllOrganizations();
      showNotification("Organization status updated successfully.");
    } catch (error) {
      Toast("error", error.message);
      console.log("error updating organization", error.message);
    } finally {
      setLoading(false);
    }
  };

  const dropdownOptions = ["active", "inactive", "unlisted"];

  return (
    <TableRow
      hover
      // onClick={(event) => handleClickRow(event, row.id)}
      role="checkbox"
      aria-checked={isItemSelected}
      tabIndex={-1}
      key={row.id}
      selected={isItemSelected}
      sx={{
        cursor: "pointer",
        height: 48,
        background: numberType === true ? "#F2F2F2" : "#fff",
      }}
    >
      <TableCell
        padding="checkbox"
        style={{ background: "#fff" }}
        onClick={(event) => handleClickRow(event, row.id)}
      >
        <Checkbox
          color="primary"
          checked={isItemSelected}
          inputProps={{
            "aria-labelledby": labelId,
          }}
        />
      </TableCell>
      <TableCell
        // component="th"
        id={labelId}
        scope="row"
        padding="none"
        onClick={handleNavigateToDetails}
        style={{ 
          ...tableTitleFieldStyles,
          width: columnWidths?.name || 200,
          minWidth: columnWidths?.name || 200,
          maxWidth: columnWidths?.name || 200,
        }}
      >
        {row?.name && truncateString(row?.name, 20)}
      </TableCell>
      <TableCell
        align="center"
        padding="none"
        style={{ 
          border: "1px solid #BABABA",
          width: columnWidths?.photo || 170,
          minWidth: columnWidths?.photo || 170,
          maxWidth: columnWidths?.photo || 170,
        }}
        // onClick={handleImagePreviewModalOpen}
        onClick={() => {
          setSelectedImage(row?.logoOP ? row?.logoOP : images.QuicktaleLogo);
          handleImagePreviewModalOpen();
        }}
      >
        {
          <img
            src={row?.logoOP ? row?.logoOP : images.QuicktaleLogo}
            alt="empty image"
            style={{ width: 45, height: 40 }}
            onError={(e) => {
              e.target.onerror = null; // Prevent infinite loop
              e.target.src = ""; // Set the source to an empty string or a placeholder image URL
            }}
          />
        }
        {/* <img
          src={row?.logoUrl}
          alt="table image"
          style={{ width: 45, height: 40 }}
        /> */}
      </TableCell>
      <TableCell 
        padding="none" 
        align="left" 
        style={{ 
          ...tableCellStyles,
          width: columnWidths?.id || 170,
          minWidth: columnWidths?.id || 170,
          maxWidth: columnWidths?.id || 170,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        }}
        title={row?.id}
      >
        {row?.id}
      </TableCell>
      <TableCell 
        padding="none" 
        align="left" 
        style={{ 
          ...tableCellStyles,
          width: columnWidths?.handle || 200,
          minWidth: columnWidths?.handle || 200,
          maxWidth: columnWidths?.handle || 200,
        }}
      >
        {row?.handle && truncateString(row?.handle, 20)}
      </TableCell>
      <TableCell 
        padding="none" 
        align="left" 
        style={{ 
          ...tableCellStyles,
          width: columnWidths?.orgContact || 200,
          minWidth: columnWidths?.orgContact || 200,
          maxWidth: columnWidths?.orgContact || 200,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',

        }}
        title={row?.orgContact}
      >
        {row?.orgContact}
      </TableCell>
      <TableCell 
        padding="none" 
        align="left" 
        style={{ 
          ...tableCellStyles,
          width: columnWidths?.createdAt || 200,
          minWidth: columnWidths?.createdAt || 200,
          maxWidth: columnWidths?.createdAt || 200,
        }}
      >
        {/* {row.creationDate} */}
        {row?.createdAt &&
          moment.unix(row?.createdAt?.seconds).format("MM-DD-YYYY HH:mm:ss")}
      </TableCell>
      <TableCell 
        padding="none" 
        align="left" 
        style={{ 
          ...tableCellStyles,
          width: columnWidths?.["userData.email"] || 200,
          minWidth: columnWidths?.["userData.email"] || 200,
          maxWidth: columnWidths?.["userData.email"] || 200,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        }}
        title={row?.orgEmail}
      >
        {row?.orgEmail}
      </TableCell>
      {/* <TableCell align="left" style={tableCellStyles}>
        {row.dateCreated}
      </TableCell> */}
      <TableCell
        align="left"
        padding="none"
        style={{
          ...tableCellStyles,
          width: columnWidths?.status || 170,
          minWidth: columnWidths?.status || 170,
          maxWidth: columnWidths?.status || 170,
          overflow: 'hidden',
          position: 'relative',
        }}
      >
        <StatusDropdown
          options={dropdownOptions}
          currentValue={row?.status}
          onChange={handleUpdateOrgStatus}
        />
      </TableCell>
      {/*Pin Order inline editable cell*/}
      <TableCell
        padding="none"
        align="left"
        style={{
          ...tableCellStyles,
          width: columnWidths?.pinOrder || 100,
          minWidth: columnWidths?.pinOrder || 100,
          maxWidth: columnWidths?.pinOrder || 100,
          paddingLeft: 4,
          paddingRight: 4,
        }}
      >
        <input
          type="text"
          value={pinOrderValue}
          onChange={(e) => {
            const val = e.target.value;
            // Allow empty or digits (with optional leading minus)
            if (val === "" || /^-?\d*$/.test(val)) {
              setPinOrderValue(val);
            }
          }}
          onBlur={handleSavePinOrder}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.target.blur();
            }
          }}
          style={{
            width: "100%",
            border: "none",
            outline: "none",
            background: "transparent",
            fontFamily: "Avenir Book, sans-serif",
            fontSize: 14,
            color: "#000000",
            textAlign: "center",
            padding: "4px 2px",
          }}
        />
      </TableCell>
    </TableRow>
  );
};

export default GAOrganizationsTableRow;

const tableTitleFieldStyles = {
  border: "1px solid #BABABA",
  color: "#00A7CD",
  fontWeight: 500,
  fontFamily: "Avenir Book, sans-serif",
  overFlow: "hidden",
  paddingLeft: 10,
};

const tableCellStyles = {
  border: "1px solid #BABABA",
  cursor: "default",
  color: "#000000",
  fontFamily: "Avenir Book, sans-serif",
  overFlow: "hidden",
  paddingLeft: 10,
};
// const tableStatusCellStyles = {
//   border: "1px solid #BABABA",
//   cursor: "pointer",
//   fontWeight: 500,
//   fontFamily: "Avenir Book, sans-serif",
// };
